export default __webpack_public_path__ + "static/media/profile.8c6cc66d.jpg";